import React, { Component } from "react";
import { connect } from "react-redux";
import { playSndFx, gameMusic } from "../../actions/actionCreators.js";
import { TweenMax } from 'gsap';

const mapStateToProps = state => {
	const g = state.game;
	return {
		isMobile: g.mobile
	};
};

const mapDispatchToProps = (dispatch, state) => {
	return {
		// boom
        playSndFx: (sfx) => dispatch(playSndFx(sfx)),
        gameMusic: track => dispatch(gameMusic( track )),
	};
};

class MeetBossView extends Component {
    constructor(props) {
		super(props);

		this.state = {
            shake: false,
            in: true
		};
	}
    componentDidMount(){
        this.props.gameMusic( "music3" ); // play music immediately
        TweenMax.delayedCall(1.5, () => this.shake());
        TweenMax.delayedCall(2, () => this.shake());
        TweenMax.delayedCall(1.75, () => this.hello());
        TweenMax.delayedCall(3, () => this.out());
        TweenMax.delayedCall(5, () => this.animateout());
    }

    hello () {
        this.props.playSndFx('meetboss');
    }

    animateout () {
        this.props.next();
    }

    shake() {
		this.setState({ shake: true })
        TweenMax.delayedCall(0.25, () => this.setState({ shake: false }))
    }
    
    out () {
        this.setState({ in: false })
    }

    render(){
        // const imgStyles = { animation: `travel 4s cubic-bezier(.22,.48,.61,.99) forwards` };

        return (
            <div className="darkpatterns2dbg">
				<div className="bodyWrapper">
					<div className={`body ${this.state.shake ? 'shake' : ''}`}>

                        <div className="meetboss">
                            <div className={`blocker ${this.state.in ? 'in' : ''}`} />
                            <div className="bossright" />
                            <div className="textleft" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const MeetBoss = connect(() => (mapStateToProps), mapDispatchToProps)(MeetBossView);
export default MeetBoss;


// WEBPACK FOOTER //
// ./src/components/scenes/MeetBoss.js